export default __webpack_public_path__ + "static/media/wifi2Security.e1280e06.png";